import * as React from 'react';
import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { authRoutes } from '../root/routes';
import MainWrapper from './MainWrapper/MainWrapper';
import { DesktopOnly } from '../utils_components/DesktopOnly';
import { useKeycloak } from '@react-keycloak/web';
import useToken from '../root/useToken';
import { useEffect } from 'react';
import { HOME_ROUTE } from '../utils/consts';
import { useIsMobile } from '../utils/hooks';
import jwtDecode from 'jwt-decode';
import '@iba-team/help-desk/dist/esm/assets/output.css';
import { AccessTypeCode } from '../types';
import { AuthRoutesI } from '../root/routes';
import ProtectedRoute from '../utils_components/ProtectedRoute';
import apiConfig from '../api/routes';


export const SsoWrapper = () => {
  const isMobile = useIsMobile();
  const {keycloak, initialized} = useKeycloak();
  const isLoggedIn = keycloak.authenticated;
  const {setToken,token } = useToken();
  const [decodedUserEmail, setDecodedUserEmail] = useState('');
  
  const onAuthAudit = () => {
    apiConfig.statisticsUsageService.auditLogin();
  };

  useEffect(() => {
    if (keycloak && initialized) {
      if (isLoggedIn && keycloak.token) {
        setToken(keycloak.token);
      }
      keycloak.onTokenExpired = () => keycloak.updateToken(300);
    }
    if (keycloak.token) {
      const userEmail = jwtDecode(keycloak.token) as unknown as {email: string};
      setDecodedUserEmail(userEmail.email);
    }
  }, [initialized, keycloak.token, isLoggedIn]);

  useEffect(() =>{
    if(isLoggedIn && keycloak.token){
      onAuthAudit();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const handleStorageChange = () => {
      if (!localStorage.getItem('token')) {
        keycloak.logout();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  if((keycloak.token && keycloak.isTokenExpired()) || !token || keycloak.token !== token){
    return null;
  }

  const renderRoutes = () => {
    const unconditionalRoutes: AuthRoutesI[] = authRoutes.filter(el => !el.accTypeCode);
    const conditionalRoutes: AuthRoutesI[] = authRoutes.filter(el => el.accTypeCode);

    return (
      <Routes>
        {unconditionalRoutes.map(({ path, Element, isMobileView, mobileTextTranslations }) =>
          <Route key={path} path={path} element={
            <MainWrapper decodedUserEmail={decodedUserEmail}>
              {!isMobileView && isMobile && mobileTextTranslations ? <DesktopOnly titleTrans={mobileTextTranslations?.title} descriptionTrans={mobileTextTranslations?.description} /> : <Element />}
            </MainWrapper>
          } />
        )}
        {conditionalRoutes.map(({ path, Element, isMobileView, mobileTextTranslations, accTypeCode }) =>
          <Route key={path} path={path} element={
            <MainWrapper decodedUserEmail={decodedUserEmail}>
              {!isMobileView && isMobile && mobileTextTranslations
                ?
                <DesktopOnly titleTrans={mobileTextTranslations?.title} descriptionTrans={mobileTextTranslations?.description} />
                :
                <ProtectedRoute itemCode={accTypeCode as AccessTypeCode}>
                  <Element />
                </ProtectedRoute>
              }
            </MainWrapper>
          } />
        )}

        <Route path={'*'} element={<Navigate to={HOME_ROUTE} />} />
      </Routes>
    );
  };

  return(
    <>
      { renderRoutes() }
    </>

  );
};
